import { HostedFieldAction } from '@endeavour/payment-integration';

const CREDIT_CARD_NUMBER = 'creditcardNumber';
const EXPIRATION_DATE = 'expirymmyyyy';
const CVV = 'cvv';
function getDevcodeFieldType(name) {
    switch (name) {
        case CREDIT_CARD_NUMBER:
            return 'CREDITCARD_NUMBER';
        case CVV:
            return 'CVV';
        case EXPIRATION_DATE:
            return 'EXPIRY_MM_YYYY';
    }
    return 'TEXT';
}
function getPattern(name) {
    switch (name) {
        case CREDIT_CARD_NUMBER:
            return '';
        case CVV:
        case EXPIRATION_DATE:
            return '[0-9]*';
    }
    return '';
}
function createHostedField({ name, hostedFieldUrl, merchantId, service, placeholder, }) {
    const devcodeFieldType = getDevcodeFieldType(name);
    const url = new URL(hostedFieldUrl);
    const origin = url.origin;
    // html comment is for syntax highlighting in editors that support it.
    return /*html*/ `
        <!DOCTYPE html>
        <html>
            <head>
                <style>
                    html, body, iframe {
                        width: 100%;
                        height: 100%;
                        padding: 0px;
                        margin: 0px;
                        border: 0;
                        display: block;
                    }
                </style>
            </head>
            <body>
                <iframe id="frame"></iframe>
                <script>
                    const frame = document.getElementById('frame');
                    const type = ${JSON.stringify(devcodeFieldType)};
                    frame.src = "${hostedFieldUrl}?mid=${merchantId}";
                    let value = undefined;
                    let hasError = false;
                    let currentHasFocus = false;
                    let hasHadFocus = false;
                    function isOurMessage(origin) {
                        return origin === ${JSON.stringify(origin)};
                    }

                    function handleMessage(message) {
                        if (!isOurMessage(message.origin) || !message.data || !message.data.action) {
                            console.info('[HostedField] Received message meant for another consumer', message);
                            return;
                        }

                        if (!window.parent) {
                            console.warn('[HostedField] Cannot correctly handle field as we are not framed');
                            return;
                        }
                        
                        const target = frame.contentWindow;
                        switch (event.data.action) {
                            case 'formData':{
                                const formData = event.data.formData;
                                if (!formData) {
                                    break;
                                }

                                if (formData.errors) {
                                    const firstKey = Object.keys(formData.errors)[0];
                                    const currentHasError = formData.errors.hasOwnProperty(firstKey);

                                    if (currentHasError !== hasError) {
                                        hasError = currentHasError;
                                        window.parent.postMessage({
                                            action: ${JSON.stringify(HostedFieldAction.ERROR)},
                                            error: '${name}.required',
                                            name: ${JSON.stringify(name)}
                                        });
                                    }
                                    break;
                                }

                                const currentValue = Object.keys(formData).map((key) => {
                                    return formData[key];
                                }).join(' ');

                                if (currentValue !== value) {
                                    value = currentValue;
                                    hasError = false;
                                    window.parent.postMessage({
                                        action: ${JSON.stringify(HostedFieldAction.INPUT)},
                                        value,
                                        name: ${JSON.stringify(name)}
                                    });
                                }
                                break;
                            }
                            case 'formSubmit':
                                window.parent.postMessage({
                                    action: ${JSON.stringify(HostedFieldAction.SUBMIT)},
                                    name: ${JSON.stringify(name)}
                                });
                                break;
                        }

                        window.parent.postMessage({
                            action: currentHasFocus ? ${JSON.stringify(HostedFieldAction.FOCUS)} : ${JSON.stringify(HostedFieldAction.BLUR)},
                            name: ${JSON.stringify(name)}
                        });
                    }

                    frame.addEventListener('load', () => {
                        const target = frame.contentWindow;

                        window.addEventListener("message", handleMessage, false);
                        target.postMessage({
                            action: 'setupSingleIframeContent',
                            styles: ${JSON.stringify(/* css */ `
                                /** Normalize devcode input styles */
                                input.input {
                                    width: 100%;
                                    height: 100%;
                                    padding: 0;
                                    border: 0 !important;
                                    outline: none !important;
                                    box-shadow: none;
                                }
                                .hosted-input-container {
                                    margin: 0;
                                    padding: 0;
                                }
                                .label {
                                    display: none;
                                }
                                .control > span > span {
                                    left: 0px !important;
                                }
                            `)},
                            fields: { 
                                ${name}: {
                                    id: ${JSON.stringify(name)},
                                    name: ${JSON.stringify(name)},
                                    type: ${JSON.stringify(devcodeFieldType)},
                                    helpKey: ${JSON.stringify(placeholder)},
                                    noAttributeValueFormatting: false,
                                    pattern: ${JSON.stringify(getPattern(name))},
                                    required: true,
                                    requiredNewPayment: true,
                                    requiredRepeatPayment: true,
                                    showIcon: true,
                                    value: undefined,
                                    visible: true,
                                    visibleOnNewPayment: true,
                                    visibleOnRepeatPayment: true
                                }
                            },
                            service: ${JSON.stringify(service)}
                        }, ${JSON.stringify(hostedFieldUrl)});

                        function getValue() {
                            target.postMessage({ action: 'get' }, ${JSON.stringify(hostedFieldUrl)});
                        }

                        /** Devcode doesn't expose getting form values as the user types. */
                        setInterval(function checkFocus(){
                            const hasFocus = document.hasFocus();
                            if (currentHasFocus === hasFocus) {
                                return;  
                            }
                            
                            if (!hasFocus) {
                                getValue(); 
                            } else {
                                hasHadFocus = true;
                            }
                            currentHasFocus = hasFocus;  
                        },100);

                        // Periodically update value
                        setInterval(function () { 
                            if (!hasHadFocus || !currentHasFocus) {
                                return;
                            }
                            getValue();
                        }, 1000);
                    });
                </script>
            </body>
        </html>
    `;
}

export { createHostedField };
